import request from './request'
import { OUTLINE_WORK_URL, OUTLINE_WORK_UPLOAD_URL, WORK_TASK_QUERY_URL } from './config'

export function createOutlineByText (payload) {
  return request.post(OUTLINE_WORK_URL, payload)
}

export function uploadOutlineFile (formData, config) {
  return request.post(OUTLINE_WORK_UPLOAD_URL, formData, config)
}

export function queryWorkTask (taskId) {
  return request.post(WORK_TASK_QUERY_URL, { taskId })
}

